import React from 'react';
import { CheckCircle } from 'lucide-react';

const AboutSection = ({ data }) => {
  const experience = data?.experience || [];
  const education = data?.education || [];
  const candidateName = data?.candidate?.name || '';
  const photoUrl = data?.candidate?.photos?.professional || '';
  const introduction = data?.bio?.introduction || '';
  const mission = data?.bio?.mission || '';

  return (
    <section id="about" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Left Column - Image */}
          <div className="order-1 lg:order-0">
            <div className="relative">
              {/* Subtle decorative accents */}
              <div className="absolute -top-8 -left-8 w-40 h-40 bg-campaign-cyan/10 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-campaign-red/10 rounded-full blur-3xl"></div>
              
              <img 
                src={photoUrl} 
                alt={candidateName}
                className="relative z-10 w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
          </div>
          
          {/* Right Column - Content - Better Spacing & Hierarchy */}
          <div className="order-0 lg:order-1">
            {/* Clear, Bold Heading */}
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-10 leading-[1.1] uppercase tracking-tight">
              Meet<br />Clianda Florence
            </h2>
            
            {/* Scannable Content with Good Spacing */}
            <div className="space-y-8 text-slate-700">
              <p className="text-lg lg:text-xl xl:text-2xl leading-relaxed">
                {introduction}
              </p>
              
              <p className="text-lg lg:text-xl xl:text-2xl leading-relaxed font-semibold text-slate-900">
                {mission}
              </p>
              
              {/* Experience - Clear Section Break */}
              <div className="pt-8">
                <h3 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-6 uppercase tracking-tight">
                  Experience & Leadership
                </h3>
                <div className="space-y-5">
                  {experience.map((exp) => (
                    <div key={exp.id} className="flex items-start gap-4">
                      <CheckCircle className="h-6 w-6 text-campaign-blue flex-shrink-0 mt-1" />
                      <div>
                        <p className="font-bold text-slate-900 text-lg lg:text-xl">{exp.role}</p>
                        <p className="text-slate-600 text-base lg:text-lg">{exp.organization}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Education - Clear Section Break */}
              <div className="pt-6">
                <h3 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-6 uppercase tracking-tight">
                  Education
                </h3>
                <ul className="space-y-4">
                  {education.map((edu, index) => (
                    <li key={index} className="flex items-start gap-4">
                      <div className="w-2.5 h-2.5 bg-campaign-red rounded-full flex-shrink-0 mt-2"></div>
                      <p className="text-slate-700 text-base lg:text-lg">{edu}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { AboutSection };
